import { FC } from 'react'

import { Request } from 'commons/utils/request'
import { CircularProgress } from 'ui/components'
import { Dialog, DialogFace } from 'ui/components/Dialog'
import { DownloadLink } from 'ui/components/DownloadLink'
import { Icon, IconName, IconSize } from 'ui/components/Icon'
import { Toast } from 'ui/components/Toast'

import { DownloadXMLDialogProps } from './DownloadXMLDialog.types'

import { s } from './styles'

export const DownloadXMLDialog: FC<DownloadXMLDialogProps> = (props) => {
  const { batch, onClose, isGenerating } = props
  if (!isGenerating && batch === null) {
    return null
  }

  const batchSuccessfullyGenerated = !isGenerating && batch !== null
  const handleError = (message: string) => Toast.error('Error', message)

  return (
    <Dialog
      face={DialogFace.DEFAULT}
      id="download-xml-dialog"
      onClose={onClose}
      title={
        <s.Title>
          {isGenerating && (
            <>
              <Icon name={IconName.INFO} size={IconSize.S} /> <span>Batch is generating...</span>
            </>
          )}
          {batchSuccessfullyGenerated && (
            <>
              <Icon name={IconName.INFO_GREEN} /> <span style={{ color: '#46d5b3' }}>Batch successfully generated</span>
            </>
          )}
        </s.Title>
      }
    >
      <s.Content>
        {isGenerating ? (
          <CircularProgress />
        ) : batchSuccessfullyGenerated ? (
          <DownloadLink
            direct
            parametersForm={{ id: batch?.id, file_type: 'xml' }}
            baseUrl={Request.urls.bank.batchFileDownload}
            name={batch?.name}
            handleError={handleError}
          >
            {batch?.name}
          </DownloadLink>
        ) : null}
      </s.Content>
    </Dialog>
  )
}
